<template>
  <div class="iDalgo-Result">
    <h1 class="iDalgo-Result__Title">{{ $t('result.title') }}</h1>
    <div class="iDalgo-Result__Nav" v-if="env !== 'sharedLink'">
      <router-link :to="{ name: 'my-result', params: { id: $route.params.id }}">
        {{ $t('result.nav.myResult') }}
      </router-link>
      <router-link :to="{ name: 'other-result', params: { id: $route.params.id }}">
        {{ $t('result.nav.otherResult') }}
      </router-link>
    </div>
    <transition name="fading" mode="out-in">
      <router-view/>
    </transition>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
  name: 'iDalgo-Result',
  computed: {
    ...mapGetters({
      env: 'app/getEnv'
    })
  }
}
</script>

<style lang="scss">
body, html {
  font-family: 'source_sans_proregular', sans-serif;
}

.iDalgo-Result {
  &__Title {
    color: #35312E;
    font-family: "source_sans_probold", sans-serif;
    font-size: 35px;
    margin: 0;
    margin-bottom: 22px;
  }

  &__Nav {
    display: flex;
    padding: 40px;
    justify-content: center;

    a {
      text-decoration: none;
      font-family: "source_sans_proregular", sans-serif;
      padding: 8px 30px 5px 30px;
      font-size: 19px;
      line-height: 19px;
      font-weight: 600;
      border: 1px solid $text_gray_dark;
      color: $text_gray_dark;
      border-radius: 300px;
      margin: 5px;
      transition: color 0.2s, border .2s;
      &.router-link-active {
        color: $color1;
        border-color: $color1;
      }
    }
  }

  @media (max-width: 640px) {
    &__Nav {
      flex-flow: column;
      flex-grow: 0;
      padding: 20px 0;

      a {
        text-align: center;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/layouts/iDalgo-Result.vue